import { TRACKING_COOKIES } from '@/constants/cookies';
import { getCookie, setCookie } from 'cookies-next';
import { forEach, toString, values } from 'lodash';
type ConsentData = {
  stamp: string;
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
  method: string;
  ver: number;
  utc: number;
  region: string;
};

export class TrackingService {
  constructor() {
    if (typeof window !== 'undefined') {
      this.attachListeners();
    }
  }

  private attachListeners() {
    // Listen for Cookiebot's event (if used)
    window.addEventListener('CookiebotOnAccept', this.init.bind(this));
    window.addEventListener('CookiebotOnDecline', this.init.bind(this));
  }

  private parseEncodedConsentData(
    encoded: string | null | undefined
  ): ConsentData | null {
    if (typeof encoded !== 'string' || !encoded.trim()) {
      console.warn('Consent data is empty or not a string.');
      return null;
    }

    try {
      const decoded = decodeURIComponent(encoded.trim());

      // Replace keys and single quotes (defensively)
      const jsonFormatted = decoded
        .replace(/'/g, '"')
        .replace(/([{,])\s*([a-zA-Z0-9_]+)\s*:/g, '$1"$2":')
        .replace(/,}/g, '}');

      if (!jsonFormatted.startsWith('{') || !jsonFormatted.endsWith('}')) {
        throw new Error('Consent data does not look like an object.');
      }

      const parsed = JSON.parse(jsonFormatted);
      return parsed as ConsentData;
    } catch (err) {
      console.warn('Consent data parsing failed:', err);
      return null;
    }
  }

  private hasUserConsented(): boolean {
    const encoded = toString(getCookie('CookieConsent')) || '';
    const consentData = this.parseEncodedConsentData(encoded);
    return !!consentData?.statistics;
  }

  init() {
    if (this.hasUserConsented()) {
      forEach(values(TRACKING_COOKIES), (cookie) => {
        setCookie(cookie, true, {
          maxAge: 60 * 60 * 24 * 365, // 1 year
        });
      });
      return;
    }
    return;
  }
}
